import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface TooltipProps {
  children: React.ReactNode;
  content: string;
  disabled?: boolean;
}
export const CustomTooltip = ({ children, content, disabled = false }: TooltipProps) => {
  if (disabled) {
    return <>{children}</>;
  }
  
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>{children}</TooltipTrigger>
        <TooltipContent sideOffset={8}>{content}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
